import { Component, OnInit } from '@angular/core';
import { EvaluationService } from 'src/app/services/evaluation/evaluation.service';
import { Vendordata } from 'src/app/model/vendordata.model';
import { Router } from '@angular/router';
import { DataSharingService } from 'src/app/auth/data-sharing.service';




@Component({
  selector: 'app-tobeevaluatedlist',
  templateUrl: './tobeevaluatedlist.component.html',
  styleUrls: ['./tobeevaluatedlist.component.css']
})
export class TobeevaluatedlistComponent implements OnInit {
  data : Vendordata;
  evaluationDataAny:any;


  constructor( private router: Router,private evaluationService : EvaluationService, private dataSharingService: DataSharingService) { }
  
  ngOnInit() {
    this.evaluationService.getVendorsForEvaluation().subscribe(
      (data) => {
        this.evaluationDataAny = data;
        this.data = this.evaluationDataAny;
        console.log(this.data);
      }
    )
  }
 

}
